import { createAsyncThunk } from '@reduxjs/toolkit';
import { BundleSubcategory } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindBundleSubcategory } from '../../bundleSubcategory/api/interface';

export const findSelectBundleSubcategory = createAsyncThunk(
  'selectBundleSubcategory/findSelectBundleSubcategory',
  async (values: FindBundleSubcategory, { rejectWithValue }) => {
    try {
      const response = await BundleSubcategory.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectBundleSubcategory = createAsyncThunk(
  'selectBundleSubcategory/searchSelectBundleSubcategory',
  async (values: FindBundleSubcategory, { rejectWithValue }) => {
    try {
      const response = await BundleSubcategory.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
